export const borderRadius = {
  small: 4,
  regular: 8,
  large: 12
};

export const generateShadows = (palette) => ({
  primary: `0 2px 8px ${palette.shadow.primary}`,
  secondary: `0 4px 10px ${palette.shadow.secondary}`
});

export const generateBorders = (palette) => ({
  primary: `1px solid ${palette.border.primary}`,
  secondary: `1px solid ${palette.border.secondary}`
});
